// Client V1 imports
const airbrake = require('client/lib/airbrake')
const { track } = require('client/lib/analytics')
const { send: ajax } = require('client/lib/request')
// Common Client v2 imports
const { navigate } = require('client-v2/common/state/router/actions')

// Action types

const INTEREST_FOLLOWING_CHANGE = 'INTEREST_FOLLOWING_CHANGE'

// Action enums

const INTEREST_FOLLOWING_CHANGE_PENDING = 'INTEREST_FOLLOWING_CHANGE_PENDING'

// Action creators

function interestFollowingChange(interestKey, isFollowing) {
  return {
    type: INTEREST_FOLLOWING_CHANGE,
    payload: {
      interestKey,
      isFollowing
    }
  }
}

function interestFollowingChangePending(interestKey) {
  return interestFollowingChange(
    interestKey,
    INTEREST_FOLLOWING_CHANGE_PENDING
  )
}

// Action dispatchers

function navigateToInterestProfile(options) {
  return navigateToInterestProfilePosts(options)
}

function navigateToInterestProfileFollowers({ interest, event, pageContext }) {
  return navigate({
    event,
    href: interestProfileFollowersHref(interest),
    pageContext
  })
}

function navigateToInterestProfilePosts({ interest, event, pageContext }) {
  return navigate({
    event,
    href: interestProfilePostsHref(interest),
    pageContext
  })
}

function toggleFollowing({ interest, pageContext }) {
  return function (dispatch) {
    const toggledFollowing = !interest.isFollowing
    const action = toggledFollowing ? 'follow' : 'unfollow'
    const method = toggledFollowing ? 'post' : 'delete'
    dispatch(interestFollowingChangePending(interest.key))
    ajax({
      url: `/api/v0.1/interest/${interest.key}/${action}`,
      method,
      data: { 'page_context': pageContext }
    })
    .then(() =>
      track(`${action}-topic`, {
        'text': interest.key,
        metabase: {
          'actioned_object_type': 'topic',
          'actioned_object_id': interest.key
        },
        'page_context': pageContext
      })
    )
    .then(() => {
      dispatch(interestFollowingChange(interest.key, toggledFollowing))
    })
    .catch(err => { airbrake.notify(err) })
  }
}


// URL helpers

function interestProfileHref(interest) {
  return interestProfilePostsHref(interest)
}

function interestProfileFollowersHref(interest) {
  return `/interest/${interest.key}/followers`
}

function interestProfilePostsHref(interest) {
  return `/interest/${interest.key}`
}

// Exports

module.exports = {
  // Types
  INTEREST_FOLLOWING_CHANGE,
  // Enums
  INTEREST_FOLLOWING_CHANGE_PENDING,
  // Creators
  interestFollowingChange,
  interestFollowingChangePending,
  // Dispatchers
  navigateToInterestProfile,
  navigateToInterestProfileFollowers,
  navigateToInterestProfilePosts,
  toggleFollowing,
  // URL helpers
  interestProfileHref,
  interestProfileFollowersHref,
  interestProfilePostsHref
}
